import { useState } from "react";
import { FaMars, FaVenus, FaTransgender } from "react-icons/fa";

export default function GenderSelect({ onSubmit }) {
  const [gender, setGender] = useState(null);

  const handleSubmit = () => {
    if (!gender) return;
    onSubmit?.(gender);
  };

  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50">
      
      {/* CARD */}
      <div className="bg-[#121212] rounded-2xl p-6 w-[90%] max-w-sm text-center shadow-xl">
        
        <h2 className="text-white text-lg font-semibold mb-2">
          Select your gender
        </h2>

        <p className="text-gray-400 text-sm mb-6">
          This helps us personalize your experience
        </p>

        {/* OPTIONS */}
        <div className="flex justify-center gap-4 mb-6">
          
          {/* MALE */}
          <button
            onClick={() => setGender("male")}
            className={`flex flex-col items-center justify-center w-24 h-24 rounded-xl border transition
              ${
                gender === "male"
                  ? "border-red-500 bg-red-500/10 scale-105"
                  : "border-white/20 hover:bg-white/5"
              }`}
          >
            <FaMars className="text-3xl text-white mb-2" />
            <span className="text-sm text-white">Male</span>
          </button>

          {/* FEMALE */}
          <button
            onClick={() => setGender("female")}
            className={`flex flex-col items-center justify-center w-24 h-24 rounded-xl border transition
              ${
                gender === "female"
                  ? "border-red-500 bg-red-500/10 scale-105"
                  : "border-white/20 hover:bg-white/5"
              }`}
          >
            <FaVenus className="text-3xl text-white mb-2" />
            <span className="text-sm text-white">Female</span>
          </button>

          {/* OTHER */}
          <button
            onClick={() => setGender("other")}
            className={`flex flex-col items-center justify-center w-24 h-24 rounded-xl border transition
              ${
                gender === "other"
                  ? "border-red-500 bg-red-500/10 scale-105"
                  : "border-white/20 hover:bg-white/5"
              }`}
          >
            <FaTransgender className="text-3xl text-white mb-2" />
            <span className="text-sm text-white">Other</span>
          </button>

        </div>

        {/* SUBMIT */}
        <button
          onClick={handleSubmit}
          disabled={!gender}
          className={`w-full py-2 rounded-full text-sm font-semibold transition ${
            gender
              ? "bg-red-500 text-white"
              : "bg-gray-700 text-gray-400 cursor-not-allowed"
          }`}
        >
          Continue
        </button>

      </div>
    </div>
  );
}